import React from 'react'
import CourseAddOnPopup from './courseAddOnPopup';
import ArrowTxtBtn from '../../../../../img/icon-txt-btn-arrow.svg';

// import redux
import { useDispatch } from 'react-redux';
import { toggleIndex } from '../redux/addOnPopupToggles/addOnPopupTogglesSlice';

/**
 * 
 * @param {Object} courseAddOn - All the information about the course add on
 * @returns 
 */
function SingleCourseAddOn({courseAddOn}) {
    const dispatch = useDispatch();

     // Item record id of the course add on
     const recordId = courseAddOn.record_id;


    // pop up toggle trigger
    const getTrigger = () => {
        // toggles pop up state
        return(
            <button onClick={() => dispatch(toggleIndex(recordId))} className="text-btn-arrow text-btn-arrow--lrg">Learn More <span className="link-arrow"><ArrowTxtBtn /></span></button>
        )
    }

    // currency formatter
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        // These options are needed to round to whole numbers if that's what you want.
        minimumFractionDigits: 2, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
        maximumFractionDigits: 2, // (causes 2500.99 to be printed as $2,501) 
      });

    // Component level JSX return statement ******************************************************
    return (
            <div className="col-flex col-lg-4 col-mdl-6 col-md-6 col-sm-6 col-xs-12">
                <div className="image-card image-card--package">
                    <div className="image-card__image">
                        <img className="image" src={courseAddOn.image.sizes["image-card"]} alt={courseAddOn.image.alt} />
                    </div>
                    <div className="image-card__content">
                        <h3 className="headline">{courseAddOn.title}</h3>
                        <div className="description">{formatter.format(Number(courseAddOn.price))}</div>
                        {/* CourseAddOnPopup trigger */}
                        {getTrigger()}
                        <CourseAddOnPopup courseAddOn={courseAddOn} />
                    </div>
                </div>
            </div>
    )
}
export default SingleCourseAddOn;